import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GradeWiseAttendanceResponseModel } from 'data/attendance/attendance.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: GradeWiseAttendanceResponseModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<GradeWiseAttendanceResponseModel[]>> = (
  _,
  action,
) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const gradeAttendanceSlice = createSlice({
  name: 'gradeAttendance',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default gradeAttendanceSlice;
